import { render, staticRenderFns } from "./HomeworkBlock.vue?vue&type=template&id=0989833e"
import script from "./HomeworkBlock.vue?vue&type=script&lang=js"
export * from "./HomeworkBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports